import React from 'react';
import { Dropdown, Flag } from '@grpn/mx-components';
import { getTranslator } from '../../../helpers/i18n';
import classNames from 'classnames';
import { LanguageOption, Language, SupportedLanguages } from '../../../types';
import styles from './language-selector.module.styl';

const translate = getTranslator('_base._languageSelector');

interface LanguageSelectorOwnProps {
  onLanguageChange: ({ language }: Language) => void;
  currentLanguage: string;
  languageOptions: LanguageOption[];
}

interface LanguageSelectorState {
  isOpen: boolean;
}

class LanguageSelector extends React.Component<LanguageSelectorOwnProps, LanguageSelectorState> {
  public readonly state: LanguageSelectorState = {
    isOpen: false,
  };

  private handleFlagClick = (): void => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  public onClose = () => {
    this.setState({ isOpen: false });
  };

  private handleItemClick = (language: string) => {
    const { onLanguageChange } = this.props;
    this.setState({ isOpen: false });
    const lang: Language = { language: language } as Language;
    onLanguageChange(lang);
  };

  private getFlagByLocale = (locale: string): SupportedLanguages => {
    const { languageOptions } = this.props;
    const languageOption = languageOptions.find(item => item.locale === locale);
    if (!languageOption) {
      throw 'locale is not supported by language selector';
    }
    return languageOption.flag as SupportedLanguages;
  };

  private getLangOptions = (): JSX.Element => {
    const { currentLanguage, languageOptions } = this.props;
    return (
      <ul className={classNames(styles.itemsWrapper)}>
        {languageOptions
          .filter(item => currentLanguage !== item.locale)
          .map(item => (
            <li
              className={classNames(styles.item)}
              key={item.locale}
              onClick={() => this.handleItemClick(item.locale)}
            >
              {translate(`${item.name}`)}
            </li>
          ))}
      </ul>
    );
  };

  render() {
    const { isOpen } = this.state;
    const { currentLanguage } = this.props;

    const trigger = (
      <span className={classNames(styles.flagicon)} onClick={this.handleFlagClick}>
        <Flag size={32} country={this.getFlagByLocale(currentLanguage)} />
      </span>
    );

    return (
      <div className={classNames(styles.container)}>
        <Dropdown
          onRequestClose={this.onClose}
          onRequestOpen={() => this.setState({ isOpen: true })}
          isOpen={isOpen}
          trigger={trigger}
          position="bottom-left"
        >
          {this.getLangOptions()}
        </Dropdown>
      </div>
    );
  }
}

export default LanguageSelector;
